import * as React from 'react';
import cx from 'classnames';
import { withNativeProps } from '@/utils/with-native-props';
import './cn-status-tag.scss';
/**
 * @category 组件
 * @description 状态标签
 */
export const CnStatusTag = (props) => {
    const { type, status, text, children } = props;
    const classes = cx({
        'cn-ui-m-status-tag': true,
        [`cn-ui-m-status-tag-${type}`]: !!type,
        [`cn-ui-m-status-tag-status-${status}`]: !!status,
    });
    return withNativeProps(props, React.createElement("div", { className: classes }, children || text));
};
CnStatusTag.displayName = 'CnStatusTag';
CnStatusTag.defaultProps = {
    type: 'normal',
};
